/**
 * Common Sentry configuration for WP pages and ng-checkout.
 */
export const commonSentryConfig = {
  environment: process.env.SENTRY_ENVIRONMENT,
  dsn: 'https://f55bad66063e28702697010b20d5ea93@o510915.ingest.sentry.io/4506740514357248',
  release: process.env.SENTRY_RELEASE,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      order_id: window?.localStorage?.getItem('transaction_id') || null,
    };

    return event;
  },
};
